import { useState } from "react";
import { toast } from "sonner";
import { Image as ImageIcon, FilePdf, DownloadSimple, X } from "@phosphor-icons/react";
import { API, downloadFile } from "@/lib/api";

const isPdf = (p) => String(p).toLowerCase().endsWith(".pdf");

const fileUrl = (p, preview = false) => {
  const token = localStorage.getItem("riq_token");
  const qs = new URLSearchParams();
  if (token) qs.set("auth", token);
  if (preview) qs.set("preview", "1");
  const s = qs.toString();
  return `${API}/files/${p}${s ? `?${s}` : ""}`;
};

function AttachmentPreview({ path, idx }) {
  const [open, setOpen] = useState(false);
  const pdf = isPdf(path);
  const download = async () => {
    try {
      await downloadFile(`/files/${path}`, `receipt_original_${idx + 1}.${path.split(".").pop()}`);
    } catch {
      toast.error("Couldn't download the original");
    }
  };
  return (
    <div data-testid={`attachment-${idx}`} className="rounded-2xl border border-riq-border overflow-hidden bg-white">
      <div className="flex items-center justify-between px-4 py-2 border-b border-riq-border text-sm">
        <span className="flex items-center gap-2 font-medium">
          {pdf ? <FilePdf size={18} weight="duotone" /> : <ImageIcon size={18} weight="duotone" />}
          {pdf ? "PDF document" : "Image"} {idx + 1}
        </span>
        <button data-testid={`attachment-download-${idx}`} onClick={download} className="flex items-center gap-1 rounded-full border border-riq-border px-3 py-1 text-xs font-medium hover:border-riq-primary transition-colors">
          <DownloadSimple size={14} weight="bold" /> Download original
        </button>
      </div>
      <button onClick={() => setOpen(true)} className="block w-full bg-gray-50">
        <img data-testid={pdf ? `attachment-pdf-${idx}` : `attachment-img-${idx}`} src={fileUrl(path, pdf)} alt={`Receipt original ${idx + 1}`} className="max-h-[420px] mx-auto object-contain" />
      </button>
      {pdf && (
        <a data-testid={`attachment-open-pdf-${idx}`} href={fileUrl(path)} target="_blank" rel="noreferrer" className="block text-center text-xs font-medium py-2 border-t border-riq-border hover:text-riq-primary transition-colors">
          Open full PDF
        </a>
      )}
      {open && (
        <div data-testid="attachment-lightbox" className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-6" onClick={() => setOpen(false)}>
          <button className="absolute top-4 right-4 text-white" aria-label="Close"><X size={28} /></button>
          <img src={fileUrl(path, pdf)} alt="Original receipt" className="max-h-[90vh] rounded-xl" />
        </div>
      )}
    </div>
  );
}

export const ReceiptAttachments = ({ paths }) => {
  if (!paths?.length) return null;
  return (
    <div data-testid="receipt-attachments" className="space-y-3">
      <h3 className="font-heading text-lg font-semibold">Original receipt</h3>
      {paths.map((p, i) => <AttachmentPreview key={p} path={p} idx={i} />)}
    </div>
  );
};
